"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkData = exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var skinToArrowWidthToHeightRatio = {
    thinArrowsLargeSelectedCircleSkin: 1,
    thinArrowsSkin: 1,
    squareButtonsSkin: 0.5,
    longArrowsLargeSelectedCircleSkin: 0.3,
};
var skinToSelectedDotSizeRatio = {
    thinArrowsLargeSelectedCircleSkin: 1.66,
    thinArrowsSkin: 1,
    squareButtonsSkin: 1,
    longArrowsLargeSelectedCircleSkin: 1.66,
};
var isBoxSlideShowComponent = function (_a) {
    var type = _a.type;
    return type === 'BoxSlideShowProperties';
};
exports.props = withCompInfo_1.withCompInfo(['skin', 'compProps'], function (_a, carmiData) {
    var skin = _a.skin, compProps = _a.compProps;
    return ({
        skin: skin,
        hasShadowLayer: isBoxSlideShowComponent(compProps),
        currentSlideIndex: 0,
        autoPlay: compProps.autoPlay,
        showNavigationButton: compProps.showNavigationButton,
        showNavigationDots: compProps.showNavigationDots,
        autoPlayInterval: compProps.autoPlayInterval * 1000,
        pauseAutoPlayOnMouseOver: compProps.pauseAutoPlayOnMouseOver,
        transition: compProps.transition,
        transitionDuration: compProps.transDuration * 1000,
        transitionReverse: compProps.direction === 'LTR',
        slidesProps: carmiData.slidesProps,
    });
});
exports.css = withCompInfo_1.withCompInfo(['skin', 'compLayout', 'compProps'], function (_a) {
    var skin = _a.skin, compLayout = _a.compLayout, compProps = _a.compProps;
    var shouldHideOverflowContent = compProps.shouldHideOverflowContent, navigationButtonSize = compProps.navigationButtonSize, navigationButtonMargin = compProps.navigationButtonMargin, navigationDotsMargin = compProps.navigationDotsMargin, showNavigationButton = compProps.showNavigationButton, showNavigationDots = compProps.showNavigationDots, navigationDotsSize = compProps.navigationDotsSize, navigationDotsGap = compProps.navigationDotsGap, transDuration = compProps.transDuration;
    var isBoxSlideShow = isBoxSlideShowComponent(compProps);
    var arrowWidthToHeightRatio = skinToArrowWidthToHeightRatio[skin];
    var arrowWidth = navigationButtonSize / arrowWidthToHeightRatio;
    var navBtnOffset = isBoxSlideShow
        ? navigationButtonMargin - 0.5 * arrowWidth
        : navigationButtonMargin;
    var navDotSizeSelected = Math.floor(navigationDotsSize * skinToSelectedDotSizeRatio[skin]);
    return {
        height: compLayout.height + "px",
        '--nav-dot-section-display': showNavigationDots ? 'block' : 'none',
        '--nav-dot-section-bottom-margin': navigationDotsMargin + "px",
        '--nav-dot-margin': navigationDotsGap / 2 + "px",
        '--nav-dot-size': navigationDotsSize + "px",
        '--nav-dot-size-selected': navDotSizeSelected + "px",
        '--nav-button-width': arrowWidth + "px",
        '--nav-button-offset': navBtnOffset + "px",
        '--nav-button-display': showNavigationButton ? 'block' : 'none',
        '--slides-overflow': shouldHideOverflowContent ? 'hidden' : 'visible',
        '--transition-duration': transDuration * 1000 + "ms",
    };
});
exports.sdkData = withCompInfo_1.withCompInfo(['compProps'], function (_a) {
    var compProps = _a.compProps;
    return ({
        showSlideButtons: compProps.showNavigationDots,
        showNavigationButtons: compProps.showNavigationButton,
    });
});
//# sourceMappingURL=SlideShowContainer.js.map